import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f11636de"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "h-main"
};
var _hoisted_2 = {
  class: "h-left"
};
var _hoisted_3 = {
  class: "menu"
};
var _hoisted_4 = {
  class: "item"
};
var _hoisted_5 = {
  class: "cell"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "txt"
  }, "大纲目录", -1);
});

var _hoisted_7 = {
  class: "submenu"
};
var _hoisted_8 = {
  class: "cell"
};

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "txt"
  }, "大纲目录", -1);
});

var _hoisted_10 = {
  class: "cell"
};

var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", {
    class: "txt"
  }, "大纲目录", -1);
});

import Search from '@/components/common/lineSearch';
import { useRoute } from 'vue-router';
export default {
  setup: function setup(__props) {
    var route = useRoute();
    var decodeUrl = decodeURIComponent('https://kmcustom.oss-cn-hangzhou.aliyuncs.com' + route.params.pdf);
    var url = 'http://jptest.kemeisoft.com/pdf/index.html?url=' + decodeUrl;
    return function (_ctx, _cache) {
      var _component_folder_opened = _resolveComponent("folder-opened");

      var _component_el_icon = _resolveComponent("el-icon");

      var _component_document = _resolveComponent("document");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_unref(Search)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_folder_opened)];
        }),
        _: 1
      }), _hoisted_6])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_document)];
        }),
        _: 1
      }), _hoisted_9]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_document)];
        }),
        _: 1
      }), _hoisted_11])])])]), _createElementVNode("div", {
        class: "h-right"
      }, [_createElementVNode("iframe", {
        class: "book",
        src: url,
        id: "ifr1",
        name: "ifr1",
        scrolling: "yes"
      }, "\r\n                <p>Your browser does not support iframes.</p>\r\n            ")])]);
    };
  }
};